import { Expose } from "class-transformer";

export class UpdateProjectHasContactDto {
  @Expose()
  projectId: string;

  @Expose()
  contactId: string;
}
